import { Box, Icon, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ICellPublishedParams } from "./interfaces";

const i18_PATH = "qualita.list.columns.";

export function CellWebPublished({ published }: ICellPublishedParams) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {!!published && (
        <Tooltip title={t(`${i18_PATH}Pubblicato`)}>
          <Icon
            color="success"
            className="fa-solid fa-globe-pointer"
            sx={{ overflow: "visible" }}
          />
        </Tooltip>
      )}
    </Box>
  );
}